var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 3.18237C11.3333 3.45852 11.1094 3.68237 10.8333 3.68237L1.49992 3.68237C1.22378 3.68237 0.999919 3.45852 0.999919 3.18237C0.999919 2.90623 1.22378 2.68237 1.49992 2.68237L10.8333 2.68237C11.1094 2.68237 11.3333 2.90623 11.3333 3.18237Z",
    fill: "#7D899C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88749 0.147179C4.08235 0.342845 4.08169 0.659427 3.88602 0.854285L1.6604 3.07071C1.59499 3.13586 1.59499 3.24177 1.66041 3.30691L3.88599 5.52293C4.08168 5.71777 4.08236 6.03435 3.88752 6.23003C3.69268 6.42571 3.37609 6.42639 3.18041 6.23155L0.95483 4.01554C0.496874 3.55955 0.496843 2.81817 0.954761 2.36214L3.18038 0.145715C3.37605 -0.0491421 3.69263 -0.0484866 3.88749 0.147179Z",
    fill: "#7D899C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.8502868d40e635aceed859123bb0533a.svg";
export { ForwardRef as ReactComponent };